export const getFieldMappingId = (journeyId: string) => {
  return `journey-${journeyId}`;
};
